import type { NavigationItemType } from '~/types/navigation';

import warehouse from '~/domain/wms/menu-item';

import logs from '~/domain/logs/menu-item';
import purchaseOrders from '~/domain/purchase-order/menu-item';
import receivingLists from '~/domain/receiving-list/menu-item';
import salesOrders from '~/domain/sales-order/menu-item';
import shippingProviders from '~/domain/shipping-provider/menu-item';
import suppliers from '~/domain/supplier/menu-item';
import users from '~/domain/user/menu-item';
import webshops from '~/domain/webshop/menu-item';

export default [
    warehouse,
    { id: 'group-receiving', title: 'Zaprimanje', type: 'group', children: [receivingLists] },
    { id: 'group-supply', title: 'Nabava', type: 'group', children: [suppliers, purchaseOrders] },
    { id: 'group-sales', title: 'Prodaja', type: 'group', children: [webshops, salesOrders] },
    { id: 'group-shipping', title: 'Dostava', type: 'group', children: [shippingProviders] },
    { id: 'group-admin', title: 'Administracija', type: 'group', children: [users, logs] },
] as NavigationItemType[];
